import Vue from 'vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ja'

Vue.use(ElementUI, { locale })
const formItemBase = Vue.options.components['ElFormItem']
const formBase = Vue.options.components['ElForm']
const formCustom = formBase.extend({
    methods: {
        setErrorField (props, msg) {
            props = [].concat(props)
            const fields = this.fields.filter(field => props.indexOf(field.prop) !== -1)
            if (!fields.length) {
                return
            }

            fields.forEach(field => {
                field.setError(msg)
            })
        }
    }
})
const formItemCustom = formItemBase.extend({
    methods: {
        setError (msg) {
            this.validateState = 'error'
            this.validateMessage = msg
        }
    }
})

Vue.component('el-form-item-custom', formItemCustom)
Vue.component('el-form-custom', formCustom)
